<template>
  <v-card>
    <ODialogBar title="Resumo dos Centros de Custo" no-close>
      <v-btn small icon class="ml-16" @click="navigate(-1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="mx-2">{{ month | moment('MMM/YYYY') }}</span>
      <v-btn small icon @click="navigate(+1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer />
    </ODialogBar>
    <OLoadingLine absolute :value="isLoading" />

    <v-card-text>
      <div class="d-flex w-full">
        <!-- Donut de faturamento + total geral -->
        <div class="oderon-col-4 d-flex flex-column align-center">
          <DonutChart
            :size="200"
            absolute
            :data="costCenterDonutData"
            :font-size="20"
          />
          <div>
            <div class="display-1 text-center">{{ totalIncome | brMoney }}</div>
            <p class="text-center">Total estimado</p>
          </div>
        </div>

        <!-- Itens numéricos -->
        <div class="oderon-col-4 d-flex flex-wrap">
          <div class="oderon-col-12 d-flex flex-column pa-4 align-center" v-for="(item, idx) in numericItems" :key="idx">
            <h1>{{ item.value }}</h1>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </v-card-text>



    <v-simple-table>
      <thead>
        <tr>
          <th class="text-left">Centro de Custo</th>
          <th class="text-right">Qtde. Instalações</th>
          <th class="text-right">Qtde. Retiradas</th>
          <th class="text-right">Valor mensal</th>
          <th class="text-right">Produtos</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in medicoes"
          :key="item.costCenter.id"
          @click="$emit('itemClicked', item)"
        >
          <td>{{ item.costCenter.name }}</td>
          <td class="text-right">{{ item.install.count }}</td>
          <td class="text-right">{{ item.remove.count }}</td>
          <td class="text-right">{{ item.proRata.value | brMoney }}</td>
          <td class="text-right">{{ strProds(item) }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import Store from './Store'
import moment from 'moment'
import { CostCenter } from '@/models'
import { sumBy } from 'oderon-commons/src/utils'
import { brMoney, brNum } from 'oderon-commons/src/formatters'
import DonutChart from 'oderon-vue/cpts/charts/DonutChart'

// Dada uma lista de totais de medicao (uma para cada CC), soma a
// prop desejada (ex: "distinctItemCount", "install.value",
// "proRata.value") dos produtos com o tipo base informado
// (ex: "oderon_fox", "keyboard" ou "camera")
function sumOfType(medicoes, type, prop) {
  let products = []
  for (let med of medicoes) {
    for (let product of med.products) {
      if (product.productType.type == type) products.push(product)
    }
  }

  return sumBy(products, prop)
}

export default {
  components: { DonutChart },
  data() {
    return {
      isLoading: false,

      // Começamos com a medição do mês SEGUINTE, para
      // ter certeza que não levamos em conta instalações e
      // retiradas, até o usuário usar os controles para navegar.
      month: moment().add(1, 'month').startOf('month'),
      medicoes: [],
      measureItems: []
    }
  },

  filters: {
    brMoney
  },

  computed: {
    totalIncome() {
      return sumBy(this.medicoes, 'totalValue')
    },

    costCenterDonutData() {
      let len = this.medicoes.length
      let mainText = len > 1 ? len + ' CCs' : '1 CC'

      return {
        segments: this.medicoes.map((med, idx) => {
          let rs = med.totalValue || 0
          let pct = rs / (this.totalIncome || 1)

          // Não é muito legal ficar um monte de cores neste
          // donut, então apenas alternaremos entre dois tons.
          let color = idx % 2 == 0 ? 'oderon' : 'oderon2'

          let label = `${med.costCenter.name}: R$ ${brNum(rs)}`
          return { value: pct, color, label }
        }),
        mainText
      }
    },

    numericItems() {
      let oderon_fox = sumOfType(
        this.medicoes,
        'oderon_fox',
        'distinctItemCount'
      )

      let camera = sumOfType(this.medicoes, 'camera', 'distinctItemCount')

      let keyboard = sumOfType(this.medicoes, 'keyboard', 'distinctItemCount')

      return [
        { text: 'Oderon Fox', value: oderon_fox },
        { text: 'Câmeras', value: camera },
        { text: 'Teclado Checklist', value: keyboard }
      ]
    }
  },

  watch: {
    month() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },

  methods: {
    navigate(n) {
      this.month = moment(this.month)
        .add(n, 'month')
        .startOf('month')
    },

    reload() {
      this.$loading(() => this.fetchData())
    },

    strProds(medicao) {
      let res = medicao.products.map((x) => {
        return x.distinctItemCount + 'x ' + x.productType.alias
      })

      return res.join(', ')
    },

    async fetchData() {
      // await this.$delay(1000)

      let ccIds = Store.row.costCenters.map((x) => x.id)
      if ( ccIds.length < 1 ) {
        this.medicoes = []
        return
      }

      let res = await CostCenter.getMultiproductMeasureTotal({
        costCenterId: ccIds,
        month: this.month.format('YYYY-MM')
      })

      for (let row of res.total) {
        row.totalValue =
          row.install.value + row.proRata.value + row.remove.value
      }

      this.medicoes = res.total
    }
  }
}
</script>

<style lang="sass">
.measureItem
  flex-basis: 0
  flex-grow: 1
  flex-shrink: 1
  text-align: center
</style>
